import { SkeletonColumnCell } from '@components/SkeletonColumnCell';
import { StatusIcon } from '@components/StatusIcon';
import { StatusIconType } from '@components/StatusIcon/enums';
import { missingValuePlaceholder } from '@utils/constants';

interface ICompletedStatus {
  completed: string;
}

export const CompletedStatus = ({ completed }: ICompletedStatus) => {
  if (completed === missingValuePlaceholder) {
    return (
      <SkeletonColumnCell
        height="14px"
        value={missingValuePlaceholder}
        variant="circular"
        width="14px"
      />
    );
  }

  const isComplete = completed === 'true';
  return (
    <StatusIcon
      type={isComplete ? StatusIconType.Success : StatusIconType.Error}
    />
  );
};
